/* eslint-disable @typescript-eslint/naming-convention */
import React, {
  useEffect, useState,
} from 'react';
import { Props } from '../types';
import { parseAssetSource } from '../props/asset';
import { ContentTypeItem, TeaserService } from '../../services/teaser';
import { StringService } from '../../services';
import { Link } from '../../services/navigation/types';

// eslint-disable-next-line max-len
const fetchTeaser = async (id: number, setTeaser: React.Dispatch<React.SetStateAction<ContentTypeItem>>) => {
  try {
    const contentType = await TeaserService.getTeaserContentType(id);
    const teaser = await TeaserService.getTeaser(id, contentType);
    setTeaser(teaser);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching teaser or contentType: ', error);
  }
};

const parseUrl = (link?: Link) => {
  const isExternal = link?.url?.length > 0;
  const isInternal = link?.story?.url?.length > 0;

  const externalUrl = isExternal ? StringService.sanitizeUrl(link.url) : undefined;
  const internalUrl = isInternal ? `/${link.story.url}`.replace('//', '/') : undefined;

  return internalUrl || externalUrl;
};

export const RocheTeaserMix = ({
  blok: {
    layout, teaser_image, teaser_url, ...props
  }, slot,
}: Props): JSX.Element => {
  const teaserImage = teaser_image?.[0];
  const [teaser, setTeaser] = useState({} as ContentTypeItem);

  const {
    force_height: propForceHeight,
    primary_action_label: propPrimaryActionLabel,
    secondary_action_label: propSecondaryActionLabel,
    secondary_action: propSecondaryAction,
    story_type: propStoryType,
    teaser_date: propTeaserDate,
    teaser_description: propTeaserDescription,
    teaser_overline: propTeaserOverline,
    teaser_title: propTeaserTitle,
  } = props;

  useEffect(() => {
    const id = teaser_url?.story?.id;
    if (!id) {
      return;
    }
    fetchTeaser(id, setTeaser);
  }, [teaser_url?.story?.id]);

  const teaserImageSrc = teaserImage?.brightcove_id
    || parseAssetSource(teaserImage?.src?.filename) || teaser?.content?.teaser_image?.filename;

  const {
    content: {
      teaser_title: fetchedTeaserTitle = '',
      teaser_text: fetchedTeaserDescription = '',
      teaser_type: fetchedStoryType = '',
    } = {},
    published_at: fetchedTeaserDate,
  } = teaser || {};

  const teaserTitle = propTeaserTitle || fetchedTeaserTitle;
  const teaserDescription = propTeaserDescription || fetchedTeaserDescription;
  const teaserDate = propTeaserDate || fetchedTeaserDate;
  const teaserOverline = propTeaserOverline;

  const teaserSecondaryAction = parseUrl(propSecondaryAction);
  const teaserUrl = parseUrl(teaser_url);

  return (
    <roche-teaser-mix
      force-height={propForceHeight}
      hide-teaser-date={props.hide_teaser_date}
      layout={layout}
      primary-action-label={propPrimaryActionLabel}
      secondary-action-label={propSecondaryActionLabel}
      secondary-action={teaserSecondaryAction}
      slot={slot}
      story-type={propStoryType || fetchedStoryType}
      target-secondary-action={propSecondaryAction?.target}
      target={teaser_url?.target}
      teaser-date={teaserDate}
      teaser-description={teaserDescription}
      teaser-image={teaserImageSrc}
      teaser-overline={teaserOverline}
      teaser-title={teaserTitle}
      teaser-url={teaserUrl}
    />
  );
};
